import React, { useState, useCallback, SyntheticEvent } from 'react';
import cn from 'classnames';

import { useTranslationContext}  from "hooks";

import classes from './SearchBlock.module.scss';


export default function SearchBlock(props: {
  activeSearch?: string;
  onSubmitSearch?: (s: string) => void;
  onDiscardSearch?: () => void;
}) {
  const { t } = useTranslationContext();
  const { activeSearch = '', onSubmitSearch = (s: string) => { }, onDiscardSearch = () => { } } = props;
  const [search, setSearch] = useState(activeSearch);
  const handleSearch = useCallback((event: SyntheticEvent<KeyboardEvent> | any) => {
    const { value } = event.target;

    setSearch(value);
  }, []);

  const handleClick = useCallback(
    (event: MouseEvent | any, type: 'clear' | 'done') => {
      event.preventDefault();
      event.stopPropagation();

      if (type === 'clear') {
        onDiscardSearch();

        return;
      }

      onSubmitSearch(search);
    },
    [onDiscardSearch, onSubmitSearch, search]
  );

  return (
    <div className={cn(classes.SearchBlock, 'SearchBlock')}>
      <input
        type="text"
        name="search"
        placeholder={t('Search by keyword')+"..."}
        defaultValue={search}
        onKeyUp={handleSearch}
      />
      <div className={classes.buttonGroup}>
        <button type="button" className={classes.cancel + ' cancel'} onClick={e => handleClick(e, 'clear')}>
          {t('Clear')}
        </button>
        <button type="button" className={classes.primary + ' primary'} onClick={e => handleClick(e, 'done')}>
          {t('Done')}
        </button>
      </div>
    </div>
  );
}
